<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/input.vue'

export default FormElement;
</script>